/*
 * @Date: 2025-04-06 20:23:47
 * @LastEditors: lifangdi
 * @LastEditTime: 2025-04-28 23:14:34
 */
export function initRem() {
  const setRemBase = () => {
    const doc = document.documentElement;
    const width = doc.clientWidth;

    const isMobile = width <= 768;
    const designWidth = isMobile ? 440 : 1920;

    const remSize = (width / designWidth) * 100;
    doc.style.fontSize = remSize + "px";
  };

  window.addEventListener("resize", setRemBase);
  setRemBase();
}
